import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { Graphics } from '../models/Dashboard'
import { PATH } from '../app.api'

@Injectable()
export class DashboardService {
	constructor(private http: HttpClient) {}

	public getGraphics(
		companyId: string,
		dateStart: string,
		dateEnd: string
	): Observable<Graphics> {
		return this.http
			.post<any>(
				`${PATH}/dashboard/graphics`,
				{ companyId, dateStart, dateEnd },
				{ headers: this.setHeader() }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getHasPlantingOpportunities(companyId: string): Observable<boolean> {
		return this.http
			.get<any>(
				`${PATH}/company/${companyId}`,
				{ headers: this.setHeader() }
			)
			.pipe(
				map(result => {
					const modules: Array<string> = result.content.modules
					return Boolean(modules && modules.includes('PLANTING'))
				})
			)
	}
		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
